import * as React from 'react';
import { v4 as uuidGenerator } from 'uuid';
import { UeContainer, UeReference } from '@oneaudi/falcon-tools';
import { StyleSocialLinkLayout } from './style';
import { IconButton } from '@oneaudi/unified-web-components';

export type SocialMediaConfig = {
  facebook: boolean;
  facebookUrl?: string;
  instagram: boolean;
  instagramUrl: string;
  twitter: boolean;
  twitterUrl: string;
  linkedln: boolean;
  linkedlnUrl: string;
  youtube: boolean;
  youtubeUrl: string;
  vimeo: boolean;
  vimeoUrl: string;
  whatsapp: boolean;
  whatsappUrl: string;
}[];

export type SocialBarProps = {
  socialMedia: SocialMediaConfig;
};

export const SocialMediaBar = ({ socialMedia }: SocialBarProps): React.ReactElement => {
  return (
    <UeContainer propertyPath="variantConfig_socialMedia" label="Social Media">
      <StyleSocialLinkLayout data-testid="pbc-social-media">
        {socialMedia.map((socialMediaLinkInfo, index: number) => {
          return (
            <React.Fragment key={uuidGenerator()}>
              {socialMediaLinkInfo.facebook ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    size="md"
                    href={socialMediaLinkInfo.facebookUrl || ''}
                    target="_blank"
                    icon="facebook"
                    aria-label="facebook"
                    variant="tertiary"
                    data-testid={`pbc-social-facebook-${index + 1}`}
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
              {socialMediaLinkInfo.instagram ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    variant="tertiary"
                    size="md"
                    href={socialMediaLinkInfo.instagramUrl}
                    target="_blank"
                    className="arrow"
                    icon="instagram"
                    aria-label="instagram"
                    data-testid={`pbc-social-instagram-${index + 1}`}
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
              {socialMediaLinkInfo.twitter ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    variant="tertiary"
                    size="md"
                    href={socialMediaLinkInfo.twitterUrl}
                    target="_blank"
                    icon="x"
                    aria-label="x"
                    data-testid={`pbc-social-x-${index + 1}`}
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
              {socialMediaLinkInfo.linkedln ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    variant="tertiary"
                    size="md"
                    href={socialMediaLinkInfo.linkedlnUrl}
                    target="_blank"
                    icon="linkedin"
                    aria-label="linkedin"
                    data-testid={`pbc-social-linkedin-${index + 1}`}
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
              {socialMediaLinkInfo.youtube ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    variant="tertiary"
                    size="md"
                    href={socialMediaLinkInfo.youtubeUrl}
                    target="_blank"
                    icon="youtube"
                    aria-label="youtube"
                    data-testid={`pbc-social-youtube-${index + 1}`}
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
              {socialMediaLinkInfo.vimeo ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    variant="tertiary"
                    size="md"
                    href={socialMediaLinkInfo.vimeoUrl}
                    target="_blank"
                    icon="vimeo"
                    aria-label="vimeo"
                    data-testid={`pbc-social-vimeo-${index + 1}`}
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
              {socialMediaLinkInfo.whatsapp ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    variant="tertiary"
                    size="md"
                    href={socialMediaLinkInfo.whatsappUrl}
                    target="_blank"
                    icon="whatsapp"
                    aria-label="whatsapp"
                    data-testid={`pbc-social-whatsapp-${index + 1}`}
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
            </React.Fragment>
          );
        })}
      </StyleSocialLinkLayout>
    </UeContainer>
  );
};
